import { render } from "./HowToUseImages.vue?vue&type=template&id=766a7e8f"
import script from "./HowToUseImages.vue?vue&type=script&lang=js"
export * from "./HowToUseImages.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__